// @ts-nocheck
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../store/userSlice";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import { BASE_URL } from "../Constants/BaseUrl";

const RegisterScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.toLowerCase());

  const handleRegister = async () => {
    if (!email || !password) {
      toast.error("Please fill in all required fields.");
      return;
    }

    if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long.");
      return;
    }

    setLoading(true);

    try {
      const responseRegister = await dispatch(
        registerUser({ email, password })
      ).unwrap();
      console.log(
        "Register response:",
        JSON.stringify(responseRegister, null, 2)
      );

      if (responseRegister?.success) {
        const data = new FormData();
        data.append("email", email);

        const config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${BASE_URL}athlete/register-otp`,
          data,
        };
        const responseOTP = await axios.request(config);
        console.log("OTP response:", JSON.stringify(responseOTP.data, null, 2));

        if (responseOTP?.data?.success) {
          toast.success("Verification email sent successfully!");

          const registrationData = {
            email,
            password,
            role: "student-athlete",
          };

          navigate("/verify-new-user", {
            state: {
              email,
              otp: responseOTP.data.otp,
              athlete_id: responseRegister?.student_athlete_id,
              registrationData,
            },
          });
        } else {
          toast.error(responseOTP?.data?.message || "Failed to send OTP.");
        }
      } else {
        toast.error(responseRegister?.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Registration error:", JSON.stringify(error, null, 2));

      let errorMessage = "Something went wrong. Please try again.";
      if (error.response) {
        errorMessage = error.response?.data?.message || errorMessage;
      } else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <div className="min-h-screen bg-[#121212] text-white px-4 py-8">
      <ToastContainer />
      <div className="max-w-xl mx-auto">
        <div className="flex flex-col items-center mb-6">
          <img
            src={LOGO}
            alt="logo"
            className="h-40 w-40 object-contain mb-2"
          />
          <img src={APPNAME} alt="app name" className="h-14 object-contain" />
        </div>

        <h2 className="text-center text-lg font-semibold uppercase text-white mb-3">
          Student-Athlete Registration
        </h2>

        <p className="text-sm mb-2">
          The Portalized app is for student-athletes, college institutions and
          coaches only. Student-athletes must sign up with their current
          school's <code>.edu</code> email address.
        </p>

        <p className="text-sm font-bold">Coaches</p>
        <p className="text-sm mb-4">
          If you are a coach accessing the Portalized platform, please ensure
          your college is registered and you have been added as a user by your
          school.
        </p>

        <p className="text-sm mb-6">
          Colleges can register at{" "}
          <a
            href="https://portalized.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#C00000] hover:underline"
          >
            portalized.com
          </a>
        </p>

        <div className="space-y-4">
          <input
            type="email"
            placeholder="Email Address"
            className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white placeholder-gray-400 focus:ring-2 focus:ring-[#C00000] focus:outline-none"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="relative w-full mb-2">
            {" "}
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-[#C00000] pr-10"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-200"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}{" "}
            </button>
          </div>

          <button
            onClick={handleRegister}
            disabled={loading}
            className="w-full bg-[#C00000] hover:bg-red-700 text-white py-3 rounded-md font-semibold transition"
          >
            {loading ? "Registering..." : "REGISTER"}
          </button>

          <button
            onClick={() => setModalVisible(true)}
            className="w-full text-sm text-white text-center mt-2"
          >
            By registering you are agreeing to our <br />
            <span className="text-[#C00000] hover:underline">
              Terms of Use and Privacy Policy
            </span>
          </button>
        </div>

        <button
          onClick={() => navigate("/login")}
          className="block mx-auto mt-6 text-sm text-[#C00000] hover:underline"
        >
          Return to Sign in Page
        </button>
      </div>

      {/* Modal */}
      {modalVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center px-4">
          <div className="bg-[#1e1e1e] rounded-md max-w-2xl w-full p-6 relative">
            <button
              onClick={() => setModalVisible(false)}
              className="absolute top-4 right-4 text-white hover:text-[#C00000]"
            >
              ✕
            </button>
            <h3 className="text-lg font-bold mb-4">
              Terms of Use and Privacy Policy
            </h3>
            <div className="text-sm max-h-[60vh] overflow-y-auto space-y-3">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                dignissim, lorem a euismod aliquam, purus velit tincidunt lacus,
                vel gravida libero urna a nulla...
              </p>
              <p>
                Integer tristique purus nec sollicitudin gravida. Donec
                consequat nulla vel rhoncus convallis...
              </p>
              {/* Add more content here */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterScreen;
